import PropTypes from 'prop-types';
import React from 'react';
import FormErrorMessage from '../FormErrorMessage';

const SessionsFormField = ({ label, children, error, ...props }) => (
  <div data-component="SessionsFormField" {...props}>
    <div className="font-semibold mb-1">{label}</div>
    <div>{children}</div>
    {error && <FormErrorMessage message={error.message} />}
  </div>
);

SessionsFormField.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  error: PropTypes.shape({
    message: PropTypes.string,
    type: PropTypes.string,
  }),
  children: PropTypes.node,
};

export default SessionsFormField;
